module.exports = __webpack_public_path__ + "static/image-mobile-tech-8482365bda16916b3a9fa9e6a92258b7.png";